/**
 * Triggers a browser download of the given text content as a file.
 *
 * @param content - The text content to download.
 * @param filename - The full filename including extension (e.g. `"report.txt"`).
 * @example
 * ```ts
 * downloadTextAsFile("Hello, world!", "greeting.txt");
 * ```
 */
export function downloadTextAsFile(content: string, filename: string): void {
  // Create a blob with the full content.
  const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  // Create an unattached anchor element.
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;

  // Attach the anchor to the DOM.
  document.body.appendChild(anchor);

  // Click the anchor to trigger the download.
  anchor.click();

  // Clean up.
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
